import React from 'react';

import { renderWhenTrue } from '../../utils';

import {
  Container,
  InnerIconContainer,
  Circle,
  Circumference,
  Icon,
  ChildrenContainer,
} from './iconWithTwoCircles.styled';
import { IconWithTwoCirclesData } from './iconWithTwoCircles.types';

export const IconWithTwoCircles: React.FC<IconWithTwoCirclesData> = (data: IconWithTwoCirclesData) => {
  const { icon, alt, children, circleBackgroundColor } = data;

  const renderChildren = renderWhenTrue(() => (
    <ChildrenContainer>{children}</ChildrenContainer>
  ));

  const renderIcon = renderWhenTrue(() => (<Icon src={icon} alt={alt} />));

  return (
    <Container>
      <InnerIconContainer>
        <Circumference />
        <Circle backgroundColor={circleBackgroundColor} />
        {renderIcon(!!icon)}
        {renderChildren(!!children)}
      </InnerIconContainer>
    </Container>
  );
}
